import React, { useState, useRef, useEffect } from "react";

function ResizableDropdown({ groups, selectedGroup, setSelectedGroup }) {
  const [width, setWidth] = useState(200); // Initial width in px
  const isResizing = useRef(false);
  const lastX = useRef(0);
 
 useEffect(() => {
    if (window.innerWidth < 640) {
      setWidth(350); // mobile initial width
    }
  }, []);
  const onMouseDown = (e) => {
    isResizing.current = true;
    lastX.current = e.clientX;
    window.addEventListener("mousemove", onMouseMove);
    window.addEventListener("mouseup", onMouseUp);
  };

  const onMouseMove = (e) => {
    if (!isResizing.current) return;
    const dx = e.clientX - lastX.current;
    setWidth((w) => Math.max(150, w + dx)); // Minimum width 150px
    lastX.current = e.clientX;
  };

  const onMouseUp = () => {
    isResizing.current = false;
    window.removeEventListener("mousemove", onMouseMove);
    window.removeEventListener("mouseup", onMouseUp);
  };

  return (
   <div
  className="relative inline-block px-2 py-2 max-xs:w-full max-xs:px-3"
  style={{ width }}
>
  <select
    className="block w-full appearance-none px-4 py-3 pr-10 bg-[#F5F2EB] text-primary-500 font-semibold rounded-md shadow-sm focus:outline-none focus:ring-2 whitespace-nowrap truncate"
    value={selectedGroup}
    onChange={(e) => setSelectedGroup(e.target.value)}
  >
    <option value="">Select Group</option>
    {groups.map((group) => (
      <option key={group.groupID} value={group.groupID}>
        {group.groupName}
      </option>
    ))}
  </select>

  {/* Dropdown Icon */}
  <div className="pointer-events-none absolute inset-y-0 right-3 flex items-center">
    <svg
      className="h-4 w-4 text-primary-500"
      viewBox="0 0 20 20"
      fill="currentColor"
    >
      <path
        fillRule="evenodd"
        d="M5.23 7.21a.75.75 0 011.06.02L10 11.585l3.71-4.355a.75.75 0 111.14.98l-4.25 5a.75.75 0 01-1.14 0l-4.25-5a.75.75 0 01.02-1.06z"
        clipRule="evenodd"
      />
    </svg>
  </div>

  {/* Resize Drag Handle */}
  <div
    onMouseDown={onMouseDown}
    style={{
      position: "absolute",
      top: 0,
      right: 0,
      width: "8px",
      height: "100%",
      cursor: "ew-resize",
      zIndex: 10,
      userSelect: "none",
    }}
  />
</div>

  );
}

export default ResizableDropdown;
